/** 《中华人民共和国网络安全法》合规（平台运营者义务：第二十三条、第二十七条、第六十一条） */

export const CYBERSECURITY_LAW = {
  ART_23: '《网络安全法》第二十三条',
  ART_27: '《网络安全法》第二十七条',
  ART_61: '《网络安全法》第六十一条'
};

/** 平台（网络运营者）合规声明 — 非用户义务 */
export const CYBERSECURITY_LAW_COMPLIANCE_NOTICE =
  '予归平台作为网络运营者，依法履行《中华人民共和国网络安全法》第二十三条（个人信息保护）、第二十七条（网络信息内容安全管理）及第六十一条（违法责任与配合调查）规定的义务。';

export const CYBERSECURITY_LAW_FOOTER_LABEL = '平台依法履行《网络安全法》义务';

/** 写入《隐私政策》：平台履行第二十三条等义务 */
export const CYBERSECURITY_LAW_PRIVACY_PARAGRAPHS = [
  '【10. 第二十三条——本平台履行的个人信息保护义务】我们收集、使用个人信息遵循合法、正当、必要原则，不收集与提供服务无关的个人信息。我们公开本《隐私政策》，明示收集、使用的目的、方式和范围，并在您勾选同意或注册/登录时征得您的同意。我们采取访问控制、传输加密等技术措施和其他必要措施，保障个人信息安全，防止泄露、毁损、丢失；未经您同意不向他人提供您的个人信息（法律法规另有规定的除外）。若发生或可能发生个人信息泄露、毁损、丢失，我们将立即采取补救措施，并依法及时告知您并向有关主管部门报告。',
  '【11. 网络日志留存（不少于六个月）】我们依法记录并留存登录、注册、发布、删除、举报、管理处置等操作审计日志，以及 API 网络访问日志；**至少留存 180 天（6 个月）**，常规日志默认留存 12 个月，管理处置与合规确认类日志长期保留。CloudBase 云库 `audit_logs` 集合作同步备份，文档默认长期保存，平台不对其作少于六个月的主动删除。日志用于防范违法犯罪、处理纠纷及配合主管部门依法调查，不用于与平台运营无关的商业用途。',
  '【12. 第二十七条——本平台履行的内容安全管理义务】我们建立内容审核、关键词拦截、举报受理与管理员处置机制，防范违法有害信息在本平台传播，并在发现后依法处置。',
  '【13. 第六十一条——本平台责任】若本平台未依法履行网络安全保护义务，须承担相应法律责任；我们亦依法配合主管部门调查，并对平台内违法内容采取限制、下架、封禁等处置措施。'
];

/** 写入《用户协议》：用户行为规范 + 平台处置（不把第23条转嫁给用户） */
export const CYBERSECURITY_LAW_AGREEMENT_PARAGRAPHS = [
  '【11. 用户行为规范】您使用本平台须遵守法律法规及公序良俗，不得发布违法有害信息，不得从事危害网络安全、侵害他人合法权益的活动（包括虐待动物、诈骗、色情低俗、宠物买卖或变相交易等，详见本协议第4条）。',
  '【12. 平台安全管理】予归平台依法履行《网络安全法》第二十七条规定的网络信息内容安全管理义务，对违规内容有权删除、下架、限制可见、限制功能或封禁账号，并依法留存必要记录。',
  '【13. 法律责任】用户违反法律法规或本协议的，须依法承担相应责任；平台可依据本协议采取处置措施，并依法配合主管部门调查（《网络安全法》第六十一条）。'
];

/** 写入《平台公约》：公益领养规范 + 平台依法管理说明 */
export const CYBERSECURITY_LAW_CONVENTION_PARAGRAPHS = [
  '【7. 平台安全管理】予归平台依法采取内容审核、举报处置、操作日志留存等措施，履行网络信息内容安全管理义务，防范违法有害信息传播。',
  '【8. 您的义务】您应文明、合法使用本平台，不发布违法有害信息，不从事危害网络安全或侵害他人合法权益的活动；发现违规内容请使用举报功能。',
  '【9. 违规处置】违反本公约或法律法规的，平台可限制或终止向您提供服务，并依法留存记录、配合主管部门调查。'
];

export const isCybersecurityLawHighlight = (para) =>
  /网络安全法|第二十三条|第二十七条|第六十一条|本平台履行|平台依法|个人信息|违法|禁止|法律责任/.test(
    String(para || '')
  );

const PROHIBITED_RULES = [
  {
    id: 'national_security',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/颠覆.{0,4}政权/i, /分裂.{0,4}国家/i, /危害国家安全/i, /恐怖(?:主义|活动|组织)/i],
    message: '内容涉嫌危害国家安全或传播恐怖信息，无法发布'
  },
  {
    id: 'violence_illegal',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/枪支|弹药|爆炸物|制毒|贩毒|吸毒/i, /买卖.{0,2}身份证|假证|伪造证件/i],
    message: '内容涉嫌暴力或违法犯罪信息，无法发布'
  },
  {
    id: 'porn_gambling',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/淫秽|色情|裸体|约炮|裸聊/i, /赌博|博彩|六合彩|网赌|赌场/i, /传销|非法集资|诈骗教程/i],
    message: '内容涉嫌淫秽色情、赌博或诈骗信息，无法发布'
  },
  {
    id: 'rumor_abuse',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/造谣|谣言|虚假疫情|煽动.{0,4}聚集/i],
    message: '内容涉嫌编造传播虚假信息或煽动扰乱秩序，无法发布'
  },
  {
    id: 'defamation',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/人肉搜索|曝光.{0,4}隐私|泄露.{0,4}身份证/i],
    message: '内容涉嫌侵害他人名誉或隐私，无法发布'
  },
  {
    id: 'illegal_trade',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [
      /有偿领养|红包领养|转让费.{0,6}领|卖猫|卖狗|出售.{0,4}猫|出售.{0,4}狗/i,
      /宠物买卖|活体交易|批发.{0,4}猫|批发.{0,4}狗|猫舍出售|犬舍出售/i,
      /后院繁殖|繁殖赚钱|配种费/i
    ],
    message: '内容涉嫌变相买卖或非法交易活体，违反平台公约'
  },
  {
    id: 'animal_abuse',
    article: CYBERSECURITY_LAW.ART_27,
    patterns: [/虐待.{0,4}猫|虐待.{0,4}狗|虐猫|虐狗|活剥|摔猫|摔狗/i],
    message: '内容涉嫌虐待动物或宣扬暴力，无法发布'
  }
];

const ID_CARD_PATTERN = /\b\d{17}[\dXx]\b/;
const PHONE_PATTERN = /(?:^|[^\d])(1[3-9]\d{9})(?:[^\d]|$)/;

const normalizeText = (input) =>
  String(input || '')
    .replace(/\s+/g, '')
    .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0));

export const scanTextCompliance = (text, options = {}) => {
  const { context = 'public', allowPhone = false } = options;
  const raw = String(text || '').trim();
  if (!raw) return { ok: true };

  const normalized = normalizeText(raw);

  for (const rule of PROHIBITED_RULES) {
    if (rule.patterns.some((p) => p.test(normalized) || p.test(raw))) {
      return {
        ok: false,
        code: rule.id,
        article: rule.article,
        message: rule.message
      };
    }
  }

  if (ID_CARD_PATTERN.test(raw)) {
    return {
      ok: false,
      code: 'pii_id',
      article: CYBERSECURITY_LAW.ART_23,
      message: `请勿在${context === 'private' ? '消息' : '公开内容'}中发布身份证号等敏感个人信息`
    };
  }

  if (!allowPhone && context !== 'private') {
    if (PHONE_PATTERN.test(raw)) {
      return {
        ok: false,
        code: 'pii_phone',
        article: CYBERSECURITY_LAW.ART_23,
        message: '公开内容请勿直接发布手机号，请使用平台私信沟通'
      };
    }
  }

  return { ok: true };
};

export const scanFieldsCompliance = (fields = [], options = {}) => {
  for (const field of fields) {
    const result = scanTextCompliance(field.value, {
      ...options,
      context: field.context || options.context || 'public'
    });
    if (!result.ok) {
      return { ...result, field: field.label || '内容' };
    }
  }
  return { ok: true };
};

export const scanPublishFormCompliance = (formData = {}) => {
  const tags = Array.isArray(formData.tags) ? formData.tags.join(' ') : '';
  return scanFieldsCompliance(
    [
      { label: '标题', value: formData.title },
      { label: '正文', value: formData.content },
      { label: '宠物名称', value: formData.name },
      { label: '标签', value: tags }
    ],
    { context: 'public', allowPhone: false }
  );
};

export const scanCommentCompliance = (content) =>
  scanTextCompliance(content, { context: 'public', allowPhone: false });

export const scanPrivateMessageCompliance = (content) =>
  scanTextCompliance(content, { context: 'private', allowPhone: true });

export const scanFeedbackCompliance = (content) =>
  scanTextCompliance(content, { context: 'public', allowPhone: false });

export const scanReportCompliance = (details) =>
  scanTextCompliance(details, { context: 'public', allowPhone: false });

export const complianceBlockMessage = (result) =>
  result?.message || '该内容不符合平台规范，请修改后重试';
